<svg
  class="c-citation-placeholder"
  viewBox="0 0 100 20"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  focusable="false"
  role="presentation"
>
  <path stroke="#000" stroke-width="5" d="M0 5h100M0 15h60" />
</svg>
